import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { ReplaySubject } from 'rxjs';

const LNG_KEY = 'PLAYROOM_LANG';

@Injectable({
  providedIn: 'root'
})

export class LanguageService {

  private langSource = new ReplaySubject<any>(1);
  language$ = this.langSource.asObservable();

  constructor(
    private translate: TranslateService,
    private storage: Storage
  ) {}

  setInitialAppLanguage() {
    let language = this.translate.getBrowserLang();
    this.translate.setDefaultLang(language);

    this.storage.get(LNG_KEY).then(val => {
      if (val) {
        this.setLanguage(val);
        this.langSource.next(val);
      } else {
        this.langSource.next(language);
      }
    })
  }

  setLanguage(lng) {
    this.translate.use(lng);
    this.langSource.next(lng);
    this.storage.set(LNG_KEY, lng)
  }
}